import { createAction } from 'app-components/flux/core/actionHelpers';

export const getMilestones = createAction('GET_MILESTONES');
export const getMilestonesSuccess = createAction('GET_MILESTONES_SUCCESS');
export const getMilestonesFailure = createAction('GET_MILESTONES_FAILURE');

export const updateMilestone = createAction(
  'UPDATE_MILESTONE',
  (payload) => payload,
  (payload, metadata) => metadata,
);
export const updateMilestoneSuccess = createAction('UPDATE_MILESTONE_SUCCESS');
export const updateMilestoneFailure = createAction('UPDATE_MILESTONE_FAILURE');

export const milestoneReceivedNotification = createAction('MILESTONE_RECEIVED_ACTION', (payload) => payload);
